import React, { useState } from "react";
import "../index.css";
import "../css/Header.css";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="wrap_sticky">
      <a
        href="https://apps.shopify.com/furloop-buyback"
        target="_blank"
        rel="noopener noreferrer"
        className="top-disclaimer w-inline-block"
      >
        <div className="text-block-2">
          Furloop Buyback is now on the Shopify App Store — install it in one click
        </div>
      </a>

      <div className="navbar md:px-36">
        <div className="flex-1" style={{ display: "inline-block" }}>
          <Link to="/" className="btn btn-ghost">
            <img
              src="https://cdn.shopify.com/s/files/1/0612/1875/0717/files/Layer_1.svg?v=1725726186" // Replace with the actual file path to your logo
              alt="FurLoop"
              className="logo-brand-1 w-embed" // Set the height of the logo
            />
          </Link>
        </div>
        <div className="flex-none">
          <ul className="menu p-[0rem] menu-horizontal flex items-center">
            {/* <li>
              <Link to="/blog" className="btn btn-outline btn-primary ml-2">Blog</Link>
            </li> */}
            <li className="flex items-center">
              <details>
                <summary className="flex items-center cursor-pointer">
                  <span className="desktop-more">More</span>
                  <div className="mobile-menu-items flex items-center">
                    <svg className="mobile-dots w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                      <circle cx="12" cy="12" r="2"/>
                      <circle cx="12" cy="5" r="2"/>
                      <circle cx="12" cy="19" r="2"/>
                    </svg>
                  </div>
                </summary>
                <ul className="bg-white rounded-t-none p-2">
                  <li>
                    <a
                      href="https://apps.shopify.com/furloop-buyback"
                      className="no-underline"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Shopify App
                    </a>
                  </li>
                  <li>
                    <Link to="/blog" style={{ textDecoration: "none" }}>
                      Articles
                    </Link>
                  </li>
                  <li>
                    <a
                      href="https://app.furloop.io/reseller/"
                      style={{ textDecoration: "none" }}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Demo Store
                    </a>
                  </li>
                </ul>
              </details>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Header;
